const { MESSAGES } = require('./strings');
import { notification } from 'antd';

import moment from 'moment';

export const handleCopy = (content, message = MESSAGES.COPY_PASSWORD_TO_CLIPBOARD) => {
    // Create element
    let inputCopy = document.createElement('input');

    let pluginName = 'PPWP Lite';
    // Set value for element
    inputCopy.value = content;

    // Add element to body
    document.body.appendChild(inputCopy);

    // Seelct and copy text to clipboard
    inputCopy.select();
    try {
        const isSuccess = document.execCommand("copy");
        if (isSuccess) {
            notification['success']({
                message: pluginName,
                description: message,
            });
        }
    } catch (err) {
        console.log("Opps, unable to copy!");
    }

    // Remove element in body
    document.body.removeChild(inputCopy);
}

export const convertDate = (date, dateFormat) => {
    if (date) {
        return moment((new Date(date * 1000)), dateFormat);
    }
    return moment(new Date(), dateFormat);
}

export const convertDateForDatePicker = (date, dateFormat) => {
    if (date) {
        return moment((new Date(date * 1000)), dateFormat);
    }
    return null;
}

export const dateFormat = 'MM/DD/YYYY';

export const disabledDate = (current) => current && current < moment().endOf('day');

export const sortWithParse = (prev, current) => {
    if (prev === null) {
        return 1;
    }
    if (current === null) {
        return -1;
    }
    return parseInt(prev) - parseInt(current);
}

export const massagePasswords = (passwords) => {
    if (!passwords) {
        return [];
    }
    const unit_time_now = Math.ceil((new Date()) / 1000);
    return passwords.map(record => {
        const { expired_date, usage_limit, hits_count, is_activated } = record;
        const validity = expired_date == null || Number.parseInt(expired_date) > unit_time_now;
        const limit = usage_limit == null || Number.parseInt(usage_limit) > Number.parseInt(hits_count);
        let labelShowIsActivated = 'Active';
        if ( ! validity || ! limit ) {
        	labelShowIsActivated = 'Expired';
        }
        if ( is_activated !== '1' ){
	        labelShowIsActivated = 'Inactive'
        }
        return { ...record, show_is_activated: labelShowIsActivated };
    })
}

export const renderAttempt = (n) => {
    return n > 1 ? "attempts" : "attempt";
}



// WEBPACK FOOTER //
// ./components/PasswordTable/util.js